import { render, staticRenderFns } from "./StudentWelcome.vue?vue&type=template&id=b7d20a94&scoped=true"
import script from "./StudentWelcome.vue?vue&type=script&lang=js"
export * from "./StudentWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d20a94",
  null
  
)

export default component.exports